import { useRef, useEffect, useState } from "react";
import testimonials from "./data/testimonials";
import ReviewCard from "./shared/ReviewCard";
import CardSection from "./CardSection";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

const SCROLL_SPEED = 1; // px per frame
const SLOW_SCROLL_SPEED = 0.4; // px per frame

const Testimonials = () => {
  const isPlace = useIsPlace();
  const scrollRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [cardSetWidth, setCardSetWidth] = useState(0);
  const cardsWrapperRef = useRef(null);

  useEffect(() => {
    if (cardsWrapperRef.current) {
      setCardSetWidth(cardsWrapperRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let animationFrameId;
    let scrollLeft = scrollContainer ? scrollContainer.scrollLeft : 0;

    const scroll = () => {
      if (scrollContainer && cardSetWidth > 0) {
        if (scrollContainer.scrollLeft >= cardSetWidth) {
          scrollLeft = 0;
        } else {
          scrollLeft += isHovered ? SLOW_SCROLL_SPEED : SCROLL_SPEED;
        }
        scrollContainer.scrollLeft = scrollLeft;
      }
      animationFrameId = window.requestAnimationFrame(scroll);
    };

    animationFrameId = window.requestAnimationFrame(scroll);
    return () => {
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [isHovered, cardSetWidth]);

  return (
    <div className="tw-relative">
      <div className="tw-absolute tw-flex tw-items-stretch tw-w-full tw-overflow-hidden [mask-image:linear-gradient(transparent,black_30%,black_70%,transparent)] tw-h-[762px]">
        <video
          src={isPlace ? "/images/place-gradient.mp4" : "/images/brivity-gradient.mp4"}
          autoPlay
          loop
          muted
          className="tw-object-cover tw-object-center tw-w-full"
        />
      </div>
      <div className="tw-relative tw-my-[168px]">
        <CardSection title="Loved by professionals just like you">
          <div
            ref={scrollRef}
            className="tw-flex tw-gap-[16px] tw-p-[16px] tw-overflow-x-hidden tw-min-h-[330px]"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div ref={cardsWrapperRef} className="tw-flex tw-gap-[16px]">
              {testimonials.map((review) => (
                <ReviewCard key={`${review.id}-a`} review={review} />
              ))}
            </div>
            <div className="tw-flex tw-gap-[16px]">
              {testimonials.map((review) => (
                <ReviewCard key={`${review.id}-b`} review={review} />
              ))}
            </div>
          </div>
        </CardSection>
      </div>
    </div>
  );
};

export default Testimonials;
